'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var columnConfig = {
  1: 'col-md-12',
  2: 'col-md-6',
  3: 'col-md-4',
  4: 'col-md-3'
};

var getColumnConfig = function getColumnConfig() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  return columnConfig[value];
};

var renderAnchorGroups = function renderAnchorGroups(group, groupIndex) {
  if (group) {
    var groupKey = '' + group.headline.text + groupIndex;
    return _react2.default.createElement(
      'div',
      { key: groupKey },
      _react2.default.createElement(
        _heading2.default,
        { level: '4', className: 'enhanced-footer__column-headline' },
        htmlToReactParser.parse(group.headline.text)
      ),
      _react2.default.createElement(
        'ul',
        null,
        group.items.map(function (item, itemIndex) {
          var itemKey = '' + item.link.text + itemIndex;
          return _react2.default.createElement(
            'li',
            { key: itemKey },
            _react2.default.createElement(
              'a',
              {
                className: 'enhanced-footer__link',
                href: item.link.href
                // adding null to prevent empty target attribute to be created
                , target: item.link.target || null,
                'data-pa-click': 'enhanced-footer-Link-' + item.link.text
              },
              item.link.text
            )
          );
        })
      )
    );
  }
  return null;
};

var renderSelectGroups = function renderSelectGroups(group, groupIndex) {
  if (group) {
    var groupKey = '' + group.headline.text + groupIndex;
    return _react2.default.createElement(
      'optgroup',
      { label: group.headline.text, key: groupKey },
      group.items.map(function (item, itemIndex) {
        var itemKey = '' + item.link.text + itemIndex;
        return _react2.default.createElement(
          'option',
          { value: item.link.href, key: itemKey },
          item.link.text
        );
      })
    );
  }
  return null;
};

var processAnchorGroups = function processAnchorGroups(columns, properties) {
  if (columns) {
    var columnClass = (0, _classnames2.default)('column-container', getColumnConfig(properties.config.numberOfColumns));
    return columns.map(function (column, columnIndex) {
      var renderedGroups = column.groups.map(function (group, idx) {
        return renderAnchorGroups(group, idx);
      });
      var columnKey = '' + columnIndex + column.groups[0].headline.text;
      return _react2.default.createElement(
        'div',
        { className: columnClass, key: columnKey },
        renderedGroups
      );
    });
  }
  return null;
};

var handleSelectChange = function handleSelectChange(e) {
  e.preventDefault();
  if (e.currentTarget && e.currentTarget.value) {
    window.location.href = e.currentTarget.value;
  }
};

var renderSelect = function renderSelect(groups, properties) {
  if (groups) {
    return _react2.default.createElement(
      'div',
      { className: 'select-container enhanced-footer__select-wrapper col-xs-12 center-block' },
      _react2.default.createElement(
        'select',
        { className: 'enhanced-footer__select', onChange: handleSelectChange },
        _react2.default.createElement(
          'option',
          null,
          properties.content.select.text
        ),
        groups
      )
    );
  }
  return null;
};

var processSelectGroups = function processSelectGroups(columns, props) {
  if (columns) {
    var selectGroups = columns.map(function (column) {
      return column.groups.map(function (group, idx) {
        return renderSelectGroups(group, idx);
      });
    });
    return renderSelect(selectGroups, props);
  }
  return null;
};

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      'div',
      { className: 'col-md-12' },
      _react2.default.createElement(
        _heading2.default,
        {
          level: '3',
          className: 'enhanced-footer__headline text-lg-left text-md-center text-xs-center'
        },
        htmlToReactParser.parse(headline.text)
      )
    );
  }
  return null;
};

var EnhancedFooter = function (_React$Component) {
  _inherits(EnhancedFooter, _React$Component);

  function EnhancedFooter() {
    _classCallCheck(this, EnhancedFooter);

    return _possibleConstructorReturn(this, (EnhancedFooter.__proto__ || Object.getPrototypeOf(EnhancedFooter)).apply(this, arguments));
  }

  _createClass(EnhancedFooter, [{
    key: 'render',
    value: function render() {
      var _props$content = this.props.content,
          headline = _props$content.headline,
          columns = _props$content.columns;
      var id = this.props.config.id;


      var enhancedFooterClasses = (0, _classnames2.default)('enhanced-footer', this.props.className);
      return _react2.default.createElement(
        'section',
        { id: id, className: enhancedFooterClasses, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            renderHeadline(headline)
          ),
          _react2.default.createElement(
            'div',
            { className: 'row enhanced-footer__select-container hidden-md-up' },
            processSelectGroups(columns, this.props)
          ),
          _react2.default.createElement(
            'div',
            { className: 'row enhanced-footer__anchor-container' },
            processAnchorGroups(columns, this.props)
          )
        )
      );
    }
  }]);

  return EnhancedFooter;
}(_react2.default.Component);

exports.default = EnhancedFooter;


EnhancedFooter.propTypes = {
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    select: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        headline: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }),
        items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          link: _propTypes2.default.shape({
            text: _propTypes2.default.string.isRequired,
            href: _propTypes2.default.string.isRequired,
            target: _propTypes2.default.string
          })
        })).isRequired
      }))
    })).isRequired
  }),
  config: _propTypes2.default.shape({
    numberOfColumns: _propTypes2.default.oneOf([1, 2, 3, 4]).isRequired,
    id: _propTypes2.default.string
  }),
  className: _propTypes2.default.string
};

EnhancedFooter.defaultProps = {
  content: {
    headline: {
      text: '44 Characters or Less to Fit On One Line'
    },
    select: {
      text: '27 Characters Max in Mobile'
    },
    columns: [{
      groups: [{
        headline: {
          text: 'Fewer than 28 characters'
        },
        items: [{
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/express-checkout',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/payflow-payment-gateway',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/website-payments-standard',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/payments-pro-hosted',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/braintree',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/sell-on-ebay',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/payment-solutions',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }]
      }]
    }, {
      groups: [{
        headline: {
          text: 'Fewer than 28 characters'
        },
        items: [{
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '/webapps/mpp/subscriptions',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }]
      }, {
        headline: {
          text: 'Fewer than 28 characters'
        },
        items: [{
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }]
      }]
    }, {
      groups: [{
        headline: {
          text: 'Fewer than 28 characters'
        },
        items: [{
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: '_blank'
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }]
      }]
    }, {
      groups: [{
        headline: {
          text: 'Fewer than 28 characters'
        },
        items: [{
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: ''
          }
        }, {
          link: {
            text: '40 Characters or Less to Fit On One Line',
            href: '#',
            target: '_blank'
          }
        }]
      }]
    }]
  },
  config: {
    numberOfColumns: 4,
    id: 'EnhancedFooter'
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/enhanced-footer/jsx/EnhancedFooter.js
// module id = 1085
// module chunks = 4